const currencyDefault = {
    name: 'Sol Peruano',
    cutted: 'PEN',
    symbol: 'S/.'
}

export {
    currencyDefault
}
